// extracted by mini-css-extract-plugin
export var addButton = "_4r-d";
export var bullets = "_4r-e";
export var compact = "_4r-2";
export var container = "_4r-j";
export var extendedWarrantyModal = "_4r-f";
export var learn = "_4r-l";
export var learnMore = "_4r-g";
export var offeringOption = "_4r-3";
export var offeringPrice = "_4r-8";
export var offeringSubtitle = "_4r-7";
export var offeringTitle = "_4r-6";
export var offeringsContainer = "_4r-0";
export var pdpTilesBackground = "_4r-n";
export var plan = "_4r-m";
export var regular = "_4r-1";
export var remove = "_4r-k";
export var seeDetailsIcon = "_4r-i";
export var seeDetailsLink = "_4r-h";
export var selectedOption = "_4r-4";
export var shieldIcon = "_4r-b";
export var shieldIconCompact = "_4r-c";
export var subtitle = "_4r-a";
export var title = "_4r-9";
export var unselectedOption = "_4r-5";